import React, { useMemo } from "react";
import UserAvatar from "../../../../component/user-avatar";
import { Box, styled, Typography } from "@mui/material";
import ChitChatMenu, {
  ChitChatMenuItem,
} from "../../../../component/chit-chat-menu";
import { useClearChat } from "../../../../api-hooks/use-clear-chat";
import { useCurrentUser } from "../../../../api-hooks/use-current-user";
import { useSelectedUser } from "../../../../api-hooks/use-selected-user";

const StyledTopBar = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0.8rem 1rem",
  backgroundColor: theme.palette.grey.A200,
}));

const StylesProfile = styled(Box)(() => ({
  display: "flex",
  columnGap: "10px",
  alignItems: "center",
}));

const ChatDetailTopBar = () => {
  const { user: loginUser } = useCurrentUser();
  const { selectedUser } = useSelectedUser();

  const { mutate } = useClearChat({
    senderId: loginUser?.id ? loginUser?.id : 0,
    receiverId: selectedUser?.userId ? selectedUser?.userId : 0,
  });

  const menuItems: ChitChatMenuItem[] = useMemo(() => {
    return [
      {
        name: "Clear Chat",
        onClick: () => {
          mutate();
        },
      },
    ];
  }, [mutate]);

  return (
    <StyledTopBar>
      <StylesProfile>
        <UserAvatar profileImage={selectedUser?.profilePicture} />
        <Typography>
          {selectedUser?.firstName} {selectedUser?.lastName}
        </Typography>
      </StylesProfile>
      <ChitChatMenu menuItems={menuItems} />
    </StyledTopBar>
  );
};

export default ChatDetailTopBar;
